// extracted by mini-css-extract-plugin
export default {"activeButton":"GenerateTranscriptsButton__activeButton___mPhjy","onHoverButton":"GenerateTranscriptsButton__onHoverButton___P2_pS"};